import { View } from 'pacto';
import { ConsoleDebug } from '../../../../../_utils/ConsoleDebug';
import { PactoHelper } from "../../../../../_utils/PactoHelper";

export class Formfield extends View {
  constructor(options) {
    super(options);

    this.logInstance = new ConsoleDebug('debug-formfield', 'Formfield');
    //this.logInstance.disableDebugMode();

    this.pactoHelper = new PactoHelper();

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
    this.onClick = this.onClick.bind(this);
    this.flagRequiredFormfield = this.flagRequiredFormfield.bind(this);
  }

  render() {

    // Ist UI Feedback aktiviert mit Attr. data-enable-ui-feedback="true" ? (farbig gerahmte Eingabefelder und Sub-Labels)
    if ( this.enableUiFeedback(this.el) ) {
      // Pflichtfelder entsprechend kennzeichnen
      this.flagRequiredFormfield();

      if ( this.el?.type == 'text' || this.el?.type == 'password' || this.el?.type == 'number' || this.el?.type == 'date') {
        this.el.addEventListener('blur', this.onBlur);
        this.el.addEventListener('keyup', this.onKeyup);
      }
    }

    this.el.addEventListener('change', this.onChange);

    // iOS Sonderfall <input type="date wird von iOS Browsern individuell implementiert, <label darüber positionieren
    if ( this.el?.type == 'date' && this.iOS() ) {
      this.el.style.marginTop = "30px";
      var labelNode = this.el.parentNode.querySelector(`label[for='${this.el.id}']`);
      if ( labelNode != null ) {
        labelNode.style.left = "0";
      }
    }

    if(this.el.tagName == 'BUTTON') {
      const submitButton = this.el
      if ( submitButton != null ) {
        submitButton.addEventListener('click', this.onClick);
      }
    }

    // Initialer Check ob Eingabefeld bereits einen Wert hat (z.B. durch Browser vorausgefüllt)
    this.checkValue(this);
  }

  destroy() {
    this.el.removeEventListener('change', this.onChange);
  }

  checkValue(formfield) {
    const ele = formfield.el;

    // Warum muss "--filled" eingefügt werden ?
    // Durch "--filled" wird der <label> Platzhalter verkleinert und rückt nach oben, damit Label und Eingaben/Datum sich nicht überschneiden

    if (ele.tagName === 'SELECT')
    {
      const list = ele.children;
      Array.from(list).forEach((el) => {
        if (el.selected && el.value !== '') {
          // Wenn "--filled" nicht vorhanden ist, dann hinzufügen
          if ( el.parentElement.classList.value.indexOf('--filled') == -1 ) {
            el.parentElement.classList.add('dropdown__select--filled');
            el.parentElement.classList.add('has-input');
          }
        }
      });
    }
    else // usually INPUT
    {
      // Bei Checkboxen macht die CSS-Klasse "--filled" keinen Sinn, die haben immer einen Wert/value
      if ( ele.type !== 'checkbox' ) {

        // Wenn
        // 1.) das Eingabefeld durch den Browser vorausgefüllt wurde (erkennbar durch eine von weiß abweichende Hintergrundfarbe)
        // 2.) der Wert nicht leer ist
        // 3.) oder Typ "date" (zeigt immer ein Datum an)
        // dann versuche die CSS-Klasse "--filled" einzufügen
        if (window.getComputedStyle(ele).backgroundColor !== 'rgb(255, 255, 255)'
          || ele.value !== ''
          || ele.type == 'date' ) {

          // Wenn "--filled" nicht vorhanden ist, dann hinzufügen
          if (ele.classList.value.indexOf('--filled') == -1) {

            // usually the first class is the component standard class e.g. textinput__input
            if (ele.classList.length > 0 && ele.classList[0].match(/--/) == null) {
              ele.classList.add(ele.classList[0] + `--filled`);
            } else {
              this.logInstance.log('Keine passende CSS-Klasse gefunden um \'ele.classList[0]--filled\' einzufügen');
            }
          }
        }
      }
    }
  }

  onChange(event) {
    // Ist UI Feedback aktiviert mit Attr. data-enable-ui-feedback="true" ? (farbig gerahmte Eingabefelder und Sub-Labels)
    if ( this.enableUiFeedback(event.target) ) {
      this.checkFormfield(event);
    }
    const { classList } = this.el;

    if (event.target.value) {
      classList.add('has-input');
    } else {
      classList.remove('has-input');
    }
  }

  onClick(event) {
    this.sendTrackingEvent(event, 'customEventPiano:formfield:button');
  }

  sendTrackingEvent(ev, eventName) {
    const {target} = ev;
    const {href, innerText, dataset, parentNode} = target;

    const customObj = {
      target: target,
      href: href,
      title: document.title,
      dataset: dataset,
      parentNode: parentNode,
      triggerComponent: 'formfield'
    };

    //event.preventDefault();
    const event = new CustomEvent(eventName, {detail: customObj});
    this.pactoHelper.triggerEvent(event);

  }

  iOS() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  onBlur(event) {
    this.checkFormfield(event);
  }

  onKeyup(event){
    // checkFormfield() nicht aufrufen, wenn das Event durch Tab oder Shift Taste ausgelöst wurde 9 => tab, 16 => shift
    var charCode = event.which || event.keyCode;
    if (!((charCode === 9) || (charCode === 16))) {
      this.checkFormfield(event);
    }
  }


  /**
   * Wenn im Formular data-enable-ui-feedback="true" nicht aktiviert ist, dann Überprüfung abbrechen
   */
  enableUiFeedback(el) {
    let enabled = false;
    if ( el.form != undefined ) {
      enabled = Boolean(parseInt(el.form.dataset.enableUiFeedback));
    }
    if ( !enabled ) {
      this.logInstance.log('data-enable-ui-feedback="1" nicht aktiviert im Formular');
    }
    return enabled;
  }

  checkFormfield(event) {
    let classPrefix = this.classPrefix(event.target);
    if ( classPrefix === '' ) {
      return; // Nur <select...> und <input...> überprüfen
    }


    let formfieldWrapper = event.target.parentNode.parentNode;
    let subLabelEl = formfieldWrapper.querySelector('.' + classPrefix + '__sub-label');
    if ( event.target.validity.valid === false) {
      formfieldWrapper.classList.add(classPrefix + '__invalid');
      formfieldWrapper.classList.remove(classPrefix + '__required');

      let html = 'Pflichtfeld'; // Default Sub-Label Text

      if ( event.target.dataset.explictInvalidMsg != undefined
        && event.target.dataset.explictInvalidMsg != '' ) {
        // Explziter Sub-Label Text vorhanden
        html = event.target.dataset.explictInvalidMsg;
      } else if ( event.target.title != undefined
        && event.target.title != '' ) {
        // Text aus dem input title-Attribut als Sub-Label verwenden
        html = event.target.title;
      }

      if ( subLabelEl == null ) {
        // Sub-Label Element unter dem Eingabefeld erstellen und in DOM einfügen
        subLabelEl = this.createElementSublabel(html, classPrefix);
        formfieldWrapper.appendChild(subLabelEl);
      } else {
        // Text in bestehendes Sub-Label Element einfügen
        const fragment = this.getDocFragmentByHtml(html);

        // Sub-Label zurücksetzen, damit Fehlermeldung nicht mehrfach sichtbar ist
        subLabelEl.innerHTML = '';
        // DocumentFragment im DOM einfügen
        subLabelEl.appendChild(fragment);
      }

    } else {
      formfieldWrapper.classList.remove(classPrefix + '__required');
      formfieldWrapper.classList.remove(classPrefix + '__invalid');
      if ( subLabelEl != null ) {
        formfieldWrapper.removeChild(subLabelEl);
      }
    }
  }

  getDocFragmentByHtml (html) {
    const range = document.createRange();
    range.selectNode(document.querySelector('body'));
    return range.createContextualFragment(html);
  }

  /**
   * Pflichtfelder entsprechend kennzeichnen
   */
  flagRequiredFormfield() {
    if ( this.el.required ) {
      const classPrefix = this.classPrefix(this.el);
      if ( classPrefix !== '' ) {
        let formfieldWrapper = this.el.parentNode.parentNode;
        formfieldWrapper.classList.add(classPrefix + '__required');
        let subLabelEl = formfieldWrapper.querySelector('.' + classPrefix + '__sub-label');
        if ( subLabelEl == null ) {
          subLabelEl = this.createElementSublabel('Pflichtfeld', classPrefix);
        }
        formfieldWrapper.appendChild(subLabelEl);
      }
    }
  }

   createElementSublabel ( html, classPrefix ) {

    const fragment = this.getDocFragmentByHtml(html);

    let subLabelEl = document.createElement('div');
    subLabelEl.classList.add(classPrefix + '__sub-label');
    subLabelEl.appendChild(fragment);
    return subLabelEl;
  }

  classPrefix ( el ) {
    let s = '';
    // Nur <select...> und <input...> überprüfen
    if ( el.nodeName == 'SELECT' ) {
      s = 'dropdown';
    } else if ( el.nodeName == 'INPUT' && ( el.type == 'text' || el.type == 'number' || el.type == 'date')  ) {
      s = 'textinput';
    } else if ( el.nodeName == 'INPUT' && el.type == 'checkbox' ) {
      s = 'checkbox';
    } else if ( el.nodeName == 'INPUT' && el.type == 'password' ) {
      s = 'password';
    }
    return s;
  }
}
